import React from 'react';
import { Alert, AlertIcon, Text } from '@chakra-ui/react';

const ImpersonationStatus = ({ impersonatedEmail }) => {
  if (!impersonatedEmail) {
    return null;
  }

  return (
    <Alert status="info" borderRadius="8px" maxW="560px">
      <AlertIcon />
      <Text>
        You are currently impersonating{' '}
        <b data-testid="current-impersonated-email">{impersonatedEmail}</b>
      </Text>
    </Alert>
  );
};

export default ImpersonationStatus;
